
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    my: { type: Boolean, default: false },
  },
  setup() {
    return { };
  },
});
